/**
 * Environment variables for the web application
 * Validates and exports environment variables with proper types
 */

interface Env {
  VITE_API_URL: string;
  VITE_GOOGLE_ENABLED: boolean;
  VITE_GITHUB_ENABLED: boolean;
  VITE_CHROME_EXTENSION_URL: string;
  VITE_FIREFOX_EXTENSION_URL: string;
  VITE_EDGE_EXTENSION_URL: string;
  VITE_SAFARI_EXTENSION_URL: string;
}

function parseBoolean(value: string | undefined): boolean {
  return value === "true" || value === "1";
}

function validateEnv(): Env {
  const env = {
    VITE_API_URL: import.meta.env.VITE_API_URL || "http://localhost:5100",
    VITE_GOOGLE_ENABLED: parseBoolean(import.meta.env.VITE_GOOGLE_ENABLED),
    VITE_GITHUB_ENABLED: parseBoolean(import.meta.env.VITE_GITHUB_ENABLED),
    VITE_CHROME_EXTENSION_URL: import.meta.env.VITE_CHROME_EXTENSION_URL || "https://chrome.google.com/webstore/detail/fiddl-dev",
    VITE_FIREFOX_EXTENSION_URL: import.meta.env.VITE_FIREFOX_EXTENSION_URL || "https://addons.mozilla.org/firefox/addon/fiddl-dev",
    VITE_EDGE_EXTENSION_URL: import.meta.env.VITE_EDGE_EXTENSION_URL || "https://microsoftedge.microsoft.com/addons/detail/fiddl-dev",
    VITE_SAFARI_EXTENSION_URL: import.meta.env.VITE_SAFARI_EXTENSION_URL || "https://apps.apple.com/app/fiddl-dev",
  };

  // Log environment variables during build (will be in build logs)
  console.log("Environment variables:", {
    VITE_API_URL: env.VITE_API_URL,
    VITE_GOOGLE_ENABLED: env.VITE_GOOGLE_ENABLED,
    VITE_GITHUB_ENABLED: env.VITE_GITHUB_ENABLED,
  });

  return env;
}

export const env = validateEnv();
